import axios from 'axios';
import { useState, useEffect, useCallback } from 'react';
import { apiConstant } from './constant';
import useConfirm from '../../../../components/common/useConfirm';
import { useQuery } from '../../../../hooks/UseQuery';
import { useNavigate } from 'react-router-dom';

const useGetData = (id: string | undefined) => {
  const [moduleData, setModuleData] = useState<any>({
    list: [],
  });
  const [error, setError] = useState(null);
  const tniTopicId = useQuery('tniTopicId');
  const employee_id = useQuery('employee_id');
  const [isLoading, setIsLoading] = useState(false);
  const [triggerRender, setTriggerRender] = useState(false);
  const [machineData, setMachineData] = useState([{}]);
  const navigate = useNavigate();
  const [department, setDepartment] = useState([{}]);
  const [Sync, confirmSync] = useConfirm(
    'SYNC',
    'Are you sure you want to sync? Save any changes before sync!'
  );

  const updateModuleData = useCallback(
    (
      updateType: 'key-pair' | 'row',
      rowIndex: number | null,
      key: string,
      newValues: any
    ) => {
      setModuleData((prev: any) => {
        const updatedModuleData: any = { ...prev };
        if (updateType === 'key-pair') {
          updatedModuleData[key] = newValues[key];
        } else if (updateType === 'row') {
          //specific row that needs updating
          if (rowIndex === null) return;
          const updatedRow = { ...updatedModuleData.list[rowIndex] };
          updatedRow[key] = newValues[key];

          if (key === 'current_level') {
            if (!updatedRow['current_level']) {
              updatedRow['is_training_required'] = null;
            } else if (updatedRow['minimum_level'] !== undefined) {
              updatedRow['is_training_required'] =
                updatedRow['current_level'] < updatedRow['minimum_level'];
            }
          }

          updatedModuleData.list[rowIndex] = updatedRow;
        }
        return updatedModuleData;
      });
    },
    []
  );

  const handleDelete = async () => {
    axios
      .delete(`/api/${apiConstant.delete}/${id}?employee_id=${employee_id}`)
      .then((res) => {
        alert('Succesfully deleted');
        navigate(-1);
      })
      .catch((err) => {
        setError(err);
        alert('cant  deleted');
      });
  };

  useEffect(() => {
    if (id) {
      setIsLoading(true);
      axios
        .get(`/api/${apiConstant.getById}/${id}`)
        .then((res) => {
          setModuleData(res.data);
          setIsLoading(false);
        })
        .catch((err) => {
          setError(err);
          setIsLoading(false);
        });
    } else {
      setIsLoading(true);
      axios
        .get(`/api/${apiConstant.getTniTopicById}/${tniTopicId}`)
        .then((res) => {
          const data = res.data;
          delete data._id;
          delete data.__v;
          delete data.updatedAt;
          delete data.createdAt;
          setModuleData(data);
          setIsLoading(false);
        })
        .catch((err) => {
          setError(err);
          setIsLoading(false);
        });
    }
  }, [triggerRender]);

  return {
    moduleData,
    isLoading,
    error,
    Sync,
    updateModuleData,
    setTriggerRender,
    handleDelete,
  };
};

export default useGetData;
